module.exports = __webpack_public_path__ + "img/tips.5e215e49.png";